<template>
  <div>
    <titleSection
      class="mt-1"
      title="Cuatrimestres"
      subtitle="Seleccione el cuatrimestre deseado"
      icon="PackageIcon"
    />

    <transition name="fade">
      <section
        v-if="shopProductsPackage && shopProductsPackage.length"
        :class="itemView"
      >
        <b-card
          v-for="product in shopProductsPackage"
          :key="product.id"
          class="ecommerce-card"
          no-body
        >

          <div class="item-img text-center">
            <b-img
              :alt="`${product.nombre}-${product.id}`"
              fluid
              class="card-img-top"
              src="@/assets/images/illustration/personalization.svg"
            />
          </div>

          <!-- Package Details -->
          <b-card-body>
            <h6 class="item-name">
              <b>{{ product.nombre }}</b>
            </h6>
            <b-card-text class="item-description">
              Paquete de materias
            </b-card-text>
          </b-card-body>

          <!-- Package Actions -->
          <div class="item-options text-center">
            <b-button
              variant="primary"
              class="btn-cart"
              @click="handleCartActionClickPackage(product)"
            >
              <feather-icon
                :icon="isPackageInCart(product) ? 'EyeIcon' : 'ShoppingCartIcon'"
                class="mr-50"
              />
              <span>{{ isPackageInCart(product) ? 'Ver orden' : 'Seleccionar' }}</span>
            </b-button>

            <b-button
              v-if="isPackageInCart(product)"
              variant="light"
              tag="a"
              class="btn-wishlist"
              @click="removeItemFromCart(product)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-50 text-danger"
              />
              <span>Remover</span>
            </b-button>
          </div>
        </b-card>
      </section>
      <div
        v-else
        class="mt-4 text-center"
      >
        <p>No hay inscripciones disponibles</p>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BImg,
  BCardText,
  BButton,
} from 'bootstrap-vue'
import titleSection from '@/views/components/title-section.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BImg,
    BCardText,
    BButton,
    titleSection,
  },
  props: {
    loader: {
      type: Object,
      required: true,
    },
    itemView: {
      type: String,
      default: 'grid-view',
    },
    shopProductsPackage: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isPackageInCart() {
      return itemPackage => this.$store.getters['eCommerce/isPackageInCart'](itemPackage)
    },
  },
  methods: {
    handleCartActionClickPackage(product) {
      if (this.isPackageInCart(product)) this.$router.push('/carrito-compras')
      else {
        this.loader.filters = true
        this.loader.content = true
        this.$store.dispatch('eCommerce/addPackageInCart', product)
          .then(response => {
            this.loader.filters = false
            this.loader.content = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Materias de ${product.nombre}`,
                text: response,
                icon: 'ShoppingCartIcon',
                variant: 'success',
              },
            },
            { timeout: 8000 })
          })
      }
    },
    removeItemFromCart(paquete) {
      this.$store.dispatch('eCommerce/removePackageFromCart', paquete)
    },
  },
}
</script>
